// Resolve route parameters
import resolveRoutedVolume from "./resolve/resolve-routed-volume";
import resolveRoutedSchoolLevel from "./resolve/resolve-routed-school-level";
import resolveRoutedSeason from "./resolve/resolve-routed-season";
import resolveRoutedSeasonContentForSchoolLevel from "./resolve/resolve-routed-season-content-for-school-level";
import resolveRoutedDay from "./resolve/resolve-routed-day";
import resolveRoutedSong from "./resolve/resolve-routed-song";
import resolveRoutedVideo from "./resolve/resolve-routed-video";

// Provide auto-fallbacks in lack of route parameters.
import autoVolume from "./auto/auto-volume";
import autoSchoolLevel from "./auto/auto-school-level";
import autoSeason from "./auto/auto-season";
import autoDay from "./auto/auto-day";

export default {
  // If any of the container's direct children is unset,
  // then the container is not done loading.
  containerLoaded: (state) => !!Object.keys(state.container).length,

  // TODO: Reconsider: shall we at all use `active`... ? We have good router guards now.

  // Volume (child of Container)
  autoVolume: (state, getters) => autoVolume({ state, getters }),
  routedVolume: (state, getters) =>
    resolveRoutedVolume(state.route, { state, getters }),
  activeVolume: (state, getters) => getters.routedVolume || getters.autoVolume,

  // School level (child of Container)
  autoSchoolLevel: (state, getters) => autoSchoolLevel({ state, getters }),
  routedSchoolLevel: (state, getters) =>
    resolveRoutedSchoolLevel(state.route, { state, getters }),
  activeSchoolLevel: (state, getters) =>
    getters.routedSchoolLevel || getters.autoSchoolLevel,

  // Season (child of Volume)
  autoSeason: (state, getters) =>
    autoSeason(getters.activeVolume, { state, getters }),
  routedSeason: (state, getters) =>
    resolveRoutedSeason(state.route, getters.activeVolume, { state, getters }),
  activeSeason: (state, getters) => getters.routedSeason || getters.autoSeason,

  // Season content for school level (child of both Season and SchoolLevel).
  // Note: No guessing here -> no `auto` / `active` getters. Only what's routed is true.
  //   Parent seasons and school levels are auto-guessing and thus routes are self-healing.
  //   If no season or school level can be guessed, or if no season content exists
  //   for the active school level (even though the season might be valid),
  //   then we simply can't answer with a different season's or school level's
  //   content. Instead, we must keep season content empty and only answer
  //   with archive content, as long as an active school level is available.
  routedSeasonContentForSchoolLevel: (state, getters) =>
    resolveRoutedSeasonContentForSchoolLevel(
      state.route,
      {
        parentSeason: getters.routedSeason,
        parentSchoolLevel: getters.activeSchoolLevel,
      },
      { state, getters },
    ),
  activeSeasonContentForSchoolLevel: (state, getters) =>
    resolveRoutedSeasonContentForSchoolLevel(
      state.route,
      {
        parentSeason: getters.activeSeason,
        parentSchoolLevel: getters.activeSchoolLevel,
      },
      { state, getters },
    ),

  // Day (child of Season Content For School Level)
  autoDay: (state, getters) =>
    autoDay(
      null,
      {
        parentVolume: getters.activeVolume,
        parentSeason: getters.activeSeason,
        parentSeasonContentForSchoolLevel:
          getters.activeSeasonContentForSchoolLevel,
      },
      { state, getters },
    ),
  routedDay: (state, getters) =>
    resolveRoutedDay(state.route, getters.activeSeasonContentForSchoolLevel, {
      state,
      getters,
    }),
  activeDay: (state, getters) => getters.routedDay || getters.autoDay,

  // TODO: Clean out
  //
  // routedPageParent: (state, getters) => getters.routedWeek || getters.routedMagazine || getters.routedYear || state.container,
  //
  // filteredRoutedPageParentPages: (state, getters) => filterPagesByNavHide(
  //   filterPagesByAgeGroup(
  //     getters.routedPageParent?.pages,
  //     getters.activeAgeGroup,
  //   ),
  // ),
  //
  // // Page (child of Container, Year, Magazine and Week)
  // autoWeekPage: (state, getters) => autoWeekPage(state.route, getters.routedWeek || getters.autoWeek, { state, getters }),
  // routedPage:   (state, getters) => resolveRoutedPage(state.route, { state, getters }),
  // activePage:   (state, getters) => getters.routedPage || getters.autoWeekPage,
  //
  // filteredActivePageSections: (state, getters) => filterPageSectionsByNavHide(
  //   filterPageSectionsByAgeGroup(
  //     getters.activePage.sections,
  //     getters.activeAgeGroup,
  //   ),
  // ),
  //
  // // Section (child of Page)
  // autoSection:   (state, getters) => autoSection(state.route, getters.routedPage, { state, getters }),
  // routedSection: (state, getters) => resolveRoutedSection(state.route, getters.routedPage, { state, getters }),
  // activeSection: (state, getters) => getters.routedSection || getters.autoSection,
  //

  routedSong: (state, getters) =>
    resolveRoutedSong(
      state.route,
      {
        parentSeasonContentForSchoolLevel:
          getters.routedSeasonContentForSchoolLevel,
        parentSchoolLevel: getters.activeSchoolLevel,
      },
      { state, getters },
    ),
  // TODO (inherited from Kind op Maandag): Auto song & active song - if we have a KaraokePlayer section,
  //       but not a route? Or do we hard-route that?
  routedVideo: (state, getters) =>
    resolveRoutedVideo(
      state.route,
      {
        parentDay: getters.routedDay,
        parentSeasonContentForSchoolLevel:
          getters.routedSeasonContentForSchoolLevel,
        parentSchoolLevel: getters.activeSchoolLevel,
      },
      { state, getters },
    ),
};
